define('webshopAttributesMergeView',[
  'module',
  'marionette',
  'underscore',
  'entities/webshop/attribute_matching',
  'template!webshopAttributesMergeView'
], function (
  Module,
  Marionette,
  _,
  MatchingApi,
  Tpl
) {
  'use strict';

  // Form shown in a ModalView: the value of the same attribute to merge options.value into
  // (the same-name ones first). Writes the chosen id into this.model ('intoId').
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-attributes-merge-view',

    events: {
      'change select.into': 'onChange'
    },

    serializeData: function () {
      var value = this.options.value;
      var name = MatchingApi.name(value).toLowerCase();
      var labels = MatchingApi.labels(this.options.values);
      var others = _.sortBy(_.reject(this.options.values, function (v) { return v.id === value.id; }), function (v) {
        return (MatchingApi.name(v).toLowerCase() === name ? '0' : '1') + MatchingApi.name(v).toLowerCase();
      });
      var options = _.map(others, function (v) {
        return {id: v.id, label: labels[v.id] + ' — ' + v.attributeMatchCount + ' / ' + v.filterMatchCount};
      });
      if (!this.model.get('intoId') && options.length)
        this.model.set('intoId', options[0].id);
      return {
        valueLabel: labels[value.id],
        counts: value.attributeMatchCount + ' / ' + value.filterMatchCount,
        options: options,
        intoId: this.model.get('intoId')
      };
    },

    onChange: function () {
      this.model.set('intoId', parseInt(this.$('select.into').val(), 10));
    }
  });
});

